export function HTMLTrapFocus(container: string, initial: string, final: string) {
    let initialElement: HTMLElement | null = document.querySelector(initial);
    let finalElement: HTMLElement | null = document.querySelector(final);
    let containerElement: HTMLElement | null = document.querySelector(container);

    if (initialElement && finalElement && containerElement) {
        reset(containerElement)
        createPortal(containerElement, 'Start', initialElement, finalElement , containerElement)
        createPortal(containerElement, 'End', initialElement, finalElement , containerElement)
    } else {
        console.error(`Components not found`, initialElement, finalElement)
    }
}

export function createPortal(target: Element, position: string, initialElement: HTMLElement, finalElement: HTMLElement , containerElement: HTMLElement) {
    var portal = document.createElement('div');
    portal.tabIndex = 0;
    portal.id = `htmlTrapFocusPortal${position}`;
    portal.onfocus = () => { transportFrom(position, initialElement, finalElement , containerElement) }
    if (position === 'Start')
        target.insertAdjacentElement('afterbegin', portal);
    else
        target.insertAdjacentElement('beforeend', portal);

}
export function transportFrom(position: string, initialElement: HTMLElement, finalElement: HTMLElement, containerElement: HTMLElement) {
    if (initialElement && finalElement && containerElement) {
        if (position === 'Start')
            finalElement.focus();
        else
            initialElement.focus();
    };
}
export function reset(containerElement: HTMLElement) {
    if (containerElement) {
        let startPortal: HTMLElement | null = containerElement.querySelector('#htmlTrapFocusPortalStart')
        let endPortal: HTMLElement | null = containerElement.querySelector('#htmlTrapFocusPortalEnd')
        if (startPortal && endPortal) {
            let parentStartParent: HTMLElement | null = startPortal.parentElement;
            let endPortalParent : HTMLElement | null = endPortal.parentElement;
            if(parentStartParent && endPortalParent){
                parentStartParent.removeChild(startPortal)
                endPortalParent.removeChild(endPortal)
            }
        }
    }
}